import React, { useEffect, useState } from "react";
import { Input } from "../../Helpers/Input/Input";
import { InputSelect } from "../../Helpers/Input/RefactoredInput";
import Button from "../../Helpers/Button/Button";
import { Switch } from "antd";
import { CloseOutlined, PlusOutlined } from "@ant-design/icons";
import trans from "../../../utils";

export default function CustomAttributes({ setFieldValue }) {
  const [type, setType] = useState("text");
  const [attributes, setAttributes] = useState({
    name: null,
    type: null,
    value: null,
  });
  const [shownAttr, setShownAttr] = useState([]);
  useEffect(() => {
    if (attributes.type === "boolean") {
      setAttributes((prev) => ({ ...prev, value: false }));
    }
  }, [attributes.type]);
  useEffect(() => {
    if (shownAttr.length === 0) {
      setFieldValue("customAttributes", null);
    } else {
      setFieldValue("customAttributes", shownAttr);
    }
  }, [shownAttr]);

  const handleTypeChange = (e) => {
    setType(e);
    setAttributes((prev) => ({
      ...prev,
      type: e,
      value: null, // Reset value when type changes
    }));
  };

  const isDisabled =
    !attributes.name?.trim() ||
    !attributes.type ||
    attributes.value === null ||
    attributes.value === "";
  return (
    <>
      <div className="d-flex align-items-center mt-20">
        <p className="fs-16 fw-500 brand-700 text-capitalize me-2">
          {trans("custom attributes")}
        </p>
        <p style={{ textTransform: "capitalize", color: "#42526E" }}>
          ({trans("optional")})
        </p>
      </div>
      <div className="row items-center">
        <div className="col-lg-3">
          <Input
            title={trans("Attribute")}
            type="text"
            placeholder={trans("Enter attribute value")}
            formstyle="form-input"
            onChange={(e) =>
              setAttributes((prev) => ({ ...prev, name: e.target.value }))
            }
            value={attributes.name || ""}
          />
        </div>
        <div className="col-lg-3">
          <InputSelect
            label={trans("Type")}
            name="type"
            id="type"
            placeholder={trans("Select type")}
            onChange={handleTypeChange}
            formstyle="form-input"
            options={[
              { label: trans("Boolean"), value: "boolean" },
              { label: trans("Text"), value: "text" },
              { label: trans("Number"), value: "number" },
            ]}
            disabled={attributes.name === null}
            value={attributes.type || ""}
          />
        </div>
        {type !== "boolean" && (
          <div className="col-lg-3">
            <Input
              title={trans("value")}
              type={type}
              placeholder={trans("Enter value")}
              formstyle="form-input"
              onChange={(e) => {
                const val = e.target.value;
                setAttributes((prev) => ({
                  ...prev,
                  value: type === "number" ? Number(val) : val,
                }));
              }}
              value={attributes.value || ""}
            />
          </div>
        )}
        {type === "boolean" && (
          <div className="col-lg-3">
            <div className={`position-relative form-input`}>
              <label className="form-label text-capitalize">
                {trans("value")}
              </label>
              <Switch
                style={{ display: "block" }}
                onChange={(e) =>
                  setAttributes((prev) => ({
                    ...prev,
                    value: e,
                  }))
                }
                checked={!!attributes.value}
              />
            </div>
          </div>
        )}
        <div className="col-lg-3">
          <Button
            type="primary"
            icon={<PlusOutlined color="#fff" />}
            text={trans("Add")}
            // style={{ transform: "translateY(30px)" }}
            disabled={isDisabled}
            onClick={async () => {
              setShownAttr((prev) => [...prev, attributes]);
              setAttributes({
                attribute: null,
                type: null,
                value: null,
              });
            }}
          />
        </div>
      </div>
      {shownAttr?.length > 0 && (
        <div className="pois-shown-attrs">
          {shownAttr?.length > 0 && (
            <div className="mt-3">
              <p className="form-label text-capitalize">
                {trans("Attributes Preview")}
              </p>
              {shownAttr.map((attr, idx) => (
                <div className="attr-preview-item" key={idx}>
                  <span className="attr-name">{attr.name}</span>
                  <div className="attr-value-wrapper">
                    <span className="attr-value">
                      {attr.type === "boolean"
                        ? attr.value
                          ? trans("On")
                          : trans("Off")
                        : attr.value}
                    </span>
                    <CloseOutlined
                      onClick={() => {
                        setShownAttr((prev) =>
                          prev.filter((_, i) => i !== idx)
                        );
                      }}
                      style={{ cursor: "pointer", marginLeft: "12px" }}
                    />
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </>
  );
}
